import type { NotificationDTO } from "@justone/shared";
import { messagePath } from "./format";
import { wikiPagePath } from "./wiki";

/** 알림 한 줄 설명 (미리보기는 따로) */
export function describeNotification(n: NotificationDTO, actor: string, place: string): string {
  switch (n.type) {
    case "mention":
      return `${actor}님이 ${place}에서 멘션했습니다`;
    case "thread_reply":
      return `${actor}님이 ${place} 스레드에 답글을 남겼습니다`;
    case "dm_expiry":
      return "DM 메시지가 곧 삭제됩니다";
    case "move_request":
      return `${actor}님이 DM을 채널로 옮기자고 합니다`;
    case "move_result":
      return "채널로 옮기기 결과";
    case "task_assigned":
      return `${actor}님이 ${place}에서 할일을 맡겼습니다`;
    case "task_status":
      return `${actor}님이 ${place} 할일을 바꿨습니다`;
    case "task_reminder":
      return "리마인더";
    case "wiki_mention":
      return `${actor}님이 위키에서 멘션했습니다`;
    case "wiki_digest":
      return "구독한 위키 페이지가 바뀌었습니다";
    case "scheduled_failed":
      return "예약 메시지";
  }
}

/** 알림을 누르면 갈 곳 */
export function notificationPath(n: NotificationDTO): string | null {
  if (n.type === "scheduled_failed") return "/drafts";
  if (n.wikiPageId !== null) return wikiPagePath(n.channelId, n.wikiPageId);
  if (n.taskId !== null) return `${n.channelId !== null ? `/c/${n.channelId}/board` : "/today"}?task=${n.taskId}`;
  if (n.type === "move_result" && n.channelId && n.messageId) return `/c/${n.channelId}?m=${n.messageId}`;
  if (n.type === "dm_expiry" || n.type === "move_request" || n.type === "move_result") return n.conversationId ? `/d/${n.conversationId}` : null;
  if (!n.messageId || (n.channelId === null && n.conversationId === null)) return null;
  return messagePath(n, n.messageId, n.rootId);
}
